import { useStytchStore } from '@/stores/stytchStore'
import { computed, unref } from 'vue'
import type { RouteLocationNormalized, NavigationGuardNext } from 'vue-router'
import { Routes } from '@/router/Routes'

export default async (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
    const stytch = useStytchStore()
    try {
        await stytch.syncSession()
    } catch {
        /* ignore */
    }
    if (stytch.isAuthenticated) {
        return next()
    }

    next({
        name: Routes.SignIn,
        params: { redirect: to.fullPath },
    })
}
